import { combineReducers } from 'redux-immutable';

import view from './View/reducer';
import list from './List/reducer';

export default combineReducers({
  view,
  list,
});
